import React from 'react';
interface SlideHeadlineProps {
  lead: string;
  follow: string;
  size?: 'large' | 'medium';
  className?: string;
}

/** Two-line confident headline: the statement, then the turn. */
export function SlideHeadline({
  lead,
  follow,
  size = 'large',
  className = ''
}: SlideHeadlineProps) {
  return <h2 className={['font-display font-semibold leading-[0.98] tracking-[-0.03em] text-navy', size === 'large' ? 'text-[44px] sm:text-[60px] xl:text-[72px]' : 'text-[38px] sm:text-[50px] xl:text-[58px]', className].join(' ')} data-id="element-45" data-mp="1y469asbguy4i">
      {lead}
      <span className="block text-navy/40" data-id="element-46" data-mp="2c4pdfoct9k1e">{follow}</span>
    </h2>;
}